import { api } from '@services';

const deleteEquipmentStatus = async (id: string): Promise<void> => {
  await api.delete<void>(`/equipmentStatus/${id}`);
};

export { deleteEquipmentStatus };
